import { EV_REGULATION_ERROR_CODE } from 'constants/booking-constants';

/**
 * Check if an error code is an area zoning error (soft or hard block)
 * @param {number} errorCode - The error code to check
 * @returns {boolean} True if the error code is 1168 or 1169
 */
export const isAreaZoningError = errorCode =>
  errorCode === EV_REGULATION_ERROR_CODE.SOFT_BLOCK ||
  errorCode === EV_REGULATION_ERROR_CODE.HARD_BLOCK;

/**
 * Check if an error code is an area zoning soft block error (1168)
 * @param {number} errorCode - The error code to check
 * @returns {boolean} True if the error code is 1168
 */
export const isAreaZoningSoftBlock = errorCode =>
  errorCode === EV_REGULATION_ERROR_CODE.SOFT_BLOCK;

/**
 * Check if an error code is an area zoning hard block error (1169)
 * @param {number} errorCode - The error code to check
 * @returns {boolean} True if the error code is 1169
 */
export const isAreaZoningHardBlock = errorCode =>
  errorCode === EV_REGULATION_ERROR_CODE.HARD_BLOCK;
